/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Type_ManageInputs */



/**
* | output |
* | --- |
* | "Manage templates" |
*
* @param {Meeting_Type_ManageInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_type_manage = /** @type {((inputs?: Meeting_Type_ManageInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Type_ManageInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Templates beheren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérer les modèles")
	return /** @type {LocalizedString} */ ("Manage templates")
});